import { render, staticRenderFns } from "./MeetingInfo.vue?vue&type=template&id=53751510&scoped=true&"
import script from "./MeetingInfo.vue?vue&type=script&lang=js&"
export * from "./MeetingInfo.vue?vue&type=script&lang=js&"
import style0 from "./MeetingInfo.vue?vue&type=style&index=0&id=53751510&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53751510",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRadio,VRadioGroup,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53751510')) {
      api.createRecord('53751510', component.options)
    } else {
      api.reload('53751510', component.options)
    }
    module.hot.accept("./MeetingInfo.vue?vue&type=template&id=53751510&scoped=true&", function () {
      api.rerender('53751510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/MeetingInfo.vue"
export default component.exports